/* Solis marketplace layer — tiny progressive enhancements. Everything works without JS. */
(function () {
  // Localization selects submit their form on change.
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-amz-autosubmit]');
    if (!s || !s.form) return;
    // Language picks may carry a matching country so the currency follows (see amz-lang-options).
    var opt = s.options && s.options[s.selectedIndex];
    var cc = s.form.querySelector('[data-amz-country]');
    if (cc && opt && opt.dataset.country) cc.value = opt.dataset.country;
    s.form.submit();
  });

  // "All" drawer: close on scrim / ✕ / Escape.
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-amz-drawer-close]')) {
      var d = e.target.closest('[data-amz-drawer]');
      if (d) { e.preventDefault(); d.open = false; }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('[data-amz-drawer][open]').forEach(function (d) { d.open = false; });
  });

  // Horizontal rails: <div data-amz-rail> with [data-amz-track], [data-amz-prev], [data-amz-next].
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-amz-prev],[data-amz-next]');
    if (!b) return;
    var rail = b.closest('[data-amz-rail]');
    var track = rail && rail.querySelector('[data-amz-track]');
    if (!track) return;
    var dir = b.hasAttribute('data-amz-next') ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
  });

  // Mobile tab bar: Categories opens the "All" drawer, Search focuses the header search field.
  document.addEventListener('click', function (e) {
    var cats = e.target.closest('[data-amz-tab-cats]');
    var d = document.querySelector('[data-amz-drawer]');
    if (cats && d) { d.open = true; return; }
    var srch = e.target.closest('[data-amz-tab-search]');
    var input = document.querySelector('.amz-search__input');
    if (srch && input) { e.preventDefault(); window.scrollTo(0, 0); input.focus(); }
  });

  // Cart count badges follow the theme's add-to-cart (Shopify standard event).
  document.addEventListener('shopify:cart:lines-update', function (e) {
    Promise.resolve(e.promise).then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-amz-cart-count]').forEach(function (n) { n.textContent = c.item_count; });
      }).catch(function () {});
  });

  // Dots under a swipe carousel: [data-amz-rail] containing [data-amz-track] + [data-amz-dots].
  document.querySelectorAll('[data-amz-dots]').forEach(function (dots) {
    var track = dots.closest('[data-amz-rail]').querySelector('[data-amz-track]');
    var n = track.children.length;
    for (var i = 0; i < n; i++) dots.appendChild(document.createElement('i'));
    function sync() {
      var k = Math.min(n - 1, Math.round(track.scrollLeft / (track.scrollWidth / n)));
      Array.prototype.forEach.call(dots.children, function (dot, j) { dot.classList.toggle('is-on', j === k); });
    }
    track.addEventListener('scroll', sync, { passive: true });
    sync();
  });
  // --- Phone (app-style) helpers; the elements they drive are only shown by amz-mobile.css. ---
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  document.addEventListener('click', function (e) {
    // Back arrow in the header: previous in-site page, else home.
    if (e.target.closest('[data-amz-back]')) {
      var same = document.referrer && document.referrer.indexOf(location.host) > -1;
      if (same && history.length > 1) history.back(); else location.href = root;
      return;
    }
    // A bar button that presses the real button elsewhere on the page. If that button is disabled or not rendered
    // (sold-out variant: no Buy Now), take the shopper to the options instead of doing nothing (2026-10-27).
    var px = e.target.closest('[data-amzm-proxy],[data-amzm-pick]');
    if (!px) return;
    e.preventDefault();
    var real = px.hasAttribute('data-amzm-proxy') && document.querySelector(px.getAttribute('data-amzm-proxy'));
    if (real && !real.disabled && real.getAttribute('aria-disabled') !== 'true') { real.click(); return; }
    var opts = document.querySelector('.amzp-variants') || document.querySelector('.amzp-box__buttons');
    if (opts) opts.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  // Bars that slide in once their anchor element has scrolled away above the viewport.
  // [data-amzm-away]: also while the anchor is still below the viewport (PDP buy bar, 2026-10-26).
  if ('IntersectionObserver' in window) {
    document.querySelectorAll('[data-amzm-reveal]').forEach(function (bar) {
      var anchor = document.querySelector(bar.getAttribute('data-amzm-reveal'));
      if (!anchor) return;
      var away = bar.hasAttribute('data-amzm-away');
      new IntersectionObserver(function (es) {
        bar.classList.toggle('is-on', !es[0].isIntersecting && (away || es[0].boundingClientRect.top < 0));
      }).observe(anchor);
    });
  }

  // Product buy bar shows "Sold out – choose another option" while the selected variant can't be bought (2026-10-27).
  var pbar = document.querySelector('.amzm-buybar[data-amzm-away]');
  var pbuy = document.querySelector('.amzp-buy');
  if (pbar && pbuy) {
    var psync = function () {
      var b = pbuy.querySelector('.add-to-cart-button');
      pbar.classList.toggle('is-soldout', !b || b.disabled || b.getAttribute('aria-disabled') === 'true');
      // Label = the real button's visible text without the icon / "added" / quantity parts.
      var cb = pbar.querySelector('.amz-btn--cart[data-amzm-proxy]');
      if (b && cb) {
        var c = b.cloneNode(true);
        c.querySelectorAll('.add-to-cart__added, .svg-wrapper, [ref="quantityDisplay"], .visually-hidden').forEach(function (n) { n.remove(); });
        var lbl = c.textContent.replace(/\s+/g, ' ').trim();
        if (lbl) cb.textContent = lbl;
      }
    };
    psync();
    var pt;
    new MutationObserver(function () { clearTimeout(pt); pt = setTimeout(psync, 60); })
      .observe(pbuy, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
  }

  // Added-to-cart sheet on the product page (2026-10-26): the theme's add only bumped the badge.
  var added = document.querySelector('[data-amz-added]');
  if (added) {
    document.addEventListener('shopify:cart:lines-update', function (e) {
      if (e.action && e.action !== 'add') return;
      Promise.resolve(e.promise).then(function (res) {
        if (res && res.detail && res.detail.didError) return;
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
          var n = added.querySelector('[data-amz-added-count]');
          if (n) n.textContent = c.item_count;
          added.hidden = false;
          var go = added.querySelector('[name="checkout"]');
          if (go) go.focus({ preventScroll: true });
        });
      }).catch(function () {});
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-amz-added-close]')) added.hidden = true;
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') added.hidden = true; });
  }
  // Live search suggestions under the header search (2026-10-28): Shopify's /search/suggest.json (locale-aware via
  // the root URL), products + collections, arrow keys / Enter / Escape. Submitting the form still opens full results.
  document.querySelectorAll('.amz-search').forEach(function (form) {
    var input = form.querySelector('.amz-search__input');
    if (!input) return;
    var list = document.createElement('ul');
    list.className = 'amz-sugg'; list.id = 'amz-sugg-' + Math.random().toString(36).slice(2, 7);
    list.setAttribute('role', 'listbox'); list.hidden = true;
    form.appendChild(list);
    input.setAttribute('aria-controls', list.id); input.setAttribute('aria-autocomplete', 'list');
    var timer, seq = 0, idx = -1;
    function close() { list.hidden = true; idx = -1; input.setAttribute('aria-expanded', 'false'); }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function show(items, q) {
      if (!items.length) { close(); return; }
      list.innerHTML = items.map(function (it) {
        var img = it.image ? '<img src="' + esc(it.image) + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=80" alt="" width="40" height="40" loading="lazy">' : '';
        return '<li role="none"><a role="option" href="' + esc(it.url) + '">' + img + '<span>' + esc(it.title) + '</span></a></li>';
      }).join('') + '<li role="none"><a role="option" class="amz-sugg__all" href="' + root + 'search?q=' + encodeURIComponent(q) + '">' +
        esc(input.getAttribute('aria-label') || 'Search') + ': “' + esc(q) + '”</a></li>';
      list.hidden = false; idx = -1; input.setAttribute('aria-expanded', 'true');
    }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        var my = ++seq;
        fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (my !== seq) return;
            var res = (d.resources && d.resources.results) || {};
            var items = (res.products || []).map(function (p) { return { title: p.title, url: p.url, image: p.image }; })
              .concat((res.collections || []).slice(0, 2).map(function (c) { return { title: c.title, url: c.url, image: null }; }));
            show(items, q);
          }).catch(close);
      }, 200);
    });
    input.addEventListener('keydown', function (e) {
      var opts = list.querySelectorAll('[role="option"]');
      if (list.hidden || !opts.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        idx = (idx + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length;
        opts.forEach(function (o, i) { o.setAttribute('aria-selected', i === idx ? 'true' : 'false'); });
      } else if (e.key === 'Enter' && idx > -1) { e.preventDefault(); location.href = opts[idx].href; }
      else if (e.key === 'Escape') close();
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  });

  // Header height for things that stick right under it (chip row on results pages).
  var hg = document.getElementById('header-group');
  function headH() { if (hg) document.documentElement.style.setProperty('--amzm-headh', hg.offsetHeight + 'px'); }
  headH(); window.addEventListener('resize', headH);
  // Image counter ("2 / 7") on the product gallery.
  document.querySelectorAll('.amzp-gal slideshow-slides').forEach(function (sc) {
    var n = sc.children.length;
    if (n < 2) return;
    var c = document.createElement('span');
    c.className = 'amzm-count'; c.setAttribute('aria-hidden', 'true'); c.hidden = true;
    sc.closest('.amzp-gal').appendChild(c);
    function sync() { c.textContent = Math.min(n, Math.round(sc.scrollLeft / sc.clientWidth) + 1) + ' / ' + n; }
    sc.addEventListener('scroll', sync, { passive: true });
    sync();
  });
})();
